webpackJsonp([152909308826437],{

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScheduleEntry = __webpack_require__(231);
	
	var _scheduleModule = __webpack_require__(338);
	
	var _scheduleModule2 = _interopRequireDefault(_scheduleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BREAK = _ScheduleEntry.ENTRY_TYPES.BREAK,
	    HOST = _ScheduleEntry.ENTRY_TYPES.HOST,
	    KEYNOTE = _ScheduleEntry.ENTRY_TYPES.KEYNOTE,
	    MEAL = _ScheduleEntry.ENTRY_TYPES.MEAL,
	    TALK = _ScheduleEntry.ENTRY_TYPES.TALK,
	    WORKSHOP = _ScheduleEntry.ENTRY_TYPES.WORKSHOP;
	
	
	var Schedule = function Schedule(_ref) {
	  var id = _ref.id;
	  return _react2.default.createElement(
	    'section',
	    { className: _scheduleModule2.default.schedule, id: id },
	    _react2.default.createElement(
	      'div',
	      { className: _scheduleModule2.default.dayHeadings },
	      _react2.default.createElement(
	        'h2',
	        { className: _scheduleModule2.default.dayHeading },
	        'May 31'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: _scheduleModule2.default.dayHeading },
	        'June 1'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _scheduleModule2.default.mobileDayLinks },
	      _react2.default.createElement(
	        'a',
	        { className: _scheduleModule2.default.mobileDayLink, href: '#day1' },
	        'Day 1'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: _scheduleModule2.default.mobileDayLink, href: '#day2' },
	        'Day 2'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _scheduleModule2.default.events },
	      _react2.default.createElement(
	        'div',
	        { className: _scheduleModule2.default.day, id: 'day1' },
	        _react2.default.createElement(
	          'h2',
	          { className: [_scheduleModule2.default.dayHeading, _scheduleModule2.default.dayHeadingMobile].join(' ') },
	          'May 31',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: _scheduleModule2.default.dayHeadingMobileDetail },
	            '(Day 1)'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '8:30 am',
	          end: '9:30 am',
	          title: 'Check-In / Breakfast',
	          type: MEAL
	        }),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '9:30 am',
	          details: 'Kolide',
	          end: '10:00 am',
	          speaker: 'Jason Meller',
	          title: 'Introduction',
	          type: HOST
	        }),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '10:00 am',
	            category: KEYNOTE,
	            details: 'Facebook',
	            end: '10:30 am',
	            speaker: 'Nick Anderson',
	            title: 'Evolving Our Open Source Community',
	            type: KEYNOTE
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Over the past two years the osquery community has increased dramatically. Not only have the number of contributions to the agent dramatically bumped, so has the number of platforms we support and richness of discussions in our community around best leveraging osquery.',
	            'We\'ll',
	            ' explore how our community has grown, problems we faced/still face, and the directions ',
	            'we\'re',
	            ' hoping to push the community forward.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '10:30 am',
	            category: 'production osquery',
	            details: 'Palantir',
	            end: '11:00 am',
	            speaker: 'Chris Long',
	            title: 'Practical System Auditing with Osquery',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'While there are many different ways to audit process executions and network events on Linux-based systems, osquery provides a fairly unique interface for collecting and filtering audit-based events. However, there are some common misconceptions surrounding the audit framework and digging through documentation on it can be quite perplexing. During this talk ',
	            'we\'ll',
	            ' cover:',
	            _react2.default.createElement(
	              'ul',
	              { className: _scheduleModule2.default.bullets },
	              _react2.default.createElement(
	                'li',
	                null,
	                'A basic overview of the audit framework'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Building a basic osquery auditing configuration'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Fine-tune auditing configurations to minimize performance impact against your systems'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Palantir currently maintains an osquery deployment consisting of thousands of hosts with auditing enabled and collects upwards of 1 billion process and socket events per day. Join this talk to learn how to gain greater visibility into high-value systems, scale an auditing deployment, or simply learn more about ',
	            'osquery\'s',
	            ' auditing features.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '11:00 am',
	            category: 'osquery Tools',
	            details: 'Netflix',
	            end: '11:30 am',
	            speaker: 'Forest Monsen',
	            title: 'An Osquery-Based Differencing Engine for Incident Response',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'During a security incident on your cloud architecture, how far have attackers penetrated? How many instances have they touched, and what have they done there? Diffy will help. Using osquery, and a selection of simple differencing and more sophisticated clustering methods, Diffy will quickly point you to those instances requiring further digital forensics actions.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '11:30 am',
	            category: 'Production osquery',
	            details: 'Stripe',
	            end: '12:00 pm',
	            speaker: 'Ben Hughes',
	            title: 'Osquery, He Knows Me',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'This talk, aimed at everyone, highlights the journey from before Osquery in my time with the Etsy security team, and some of the tooling and problems we faced. The wrong decisions ',
	            'I\'ve',
	            ' made, so you can learn from my foolish hubris. To a number of thousand deployment of Osquery (and fleet and some not so fleet) at Stripe.'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '12:00 pm',
	          end: '1:00 pm',
	          title: 'Lunch',
	          type: MEAL
	        }),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '1:00 pm',
	            category: 'osquery Tools',
	            details: 'Kolide',
	            end: '1:30 pm',
	            speaker: 'Mike Arpaia',
	            title: 'Instrumenting Dynamic Environments with Source Control, Peer Review, and Decentralized Intelligence Distribution',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Osquery configurations often start simple and static, but, as the complexity of an osquery deployment grows, the level of dynamicism grows to where a complex server installation is required to group sets of hosts together and target them for analytics and threat hunting.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This talk introduces some lessons learned from Kubernetes, a container orchestration platform, on how to effectively decouple and manage configurations of interrelated components.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We will discuss how to reason about higher level instrumentation objectives and share components as decentralized, atomically distributable intelligence.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finally, the open-source ecosystem and established best practices will be explored so that attendees can begin implementing this way of managing and sharing host instrumentation capabilities and see immediate improvements to their instrumentation capabilities.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '1:30 pm',
	            category: 'osquery Development',
	            details: 'Facebook',
	            end: '2:00 pm',
	            speaker: 'Michael Lynn',
	            title: 'Fact Finding',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The macOS UI provides a large amount of device information - but not every interface has a counterpart command-line tool providing access to the same details. This talk will focus on using tools like Hopper to reverse engineer the code and APIs behind information displays you see everyday and how to integrate access to them into your own tools.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '2:00 pm',
	            category: 'osquery Tools',
	            details: 'University Hamburg',
	            end: '2:30 pm',
	            speaker: 'Steffen Haas',
	            title: 'Bro-Osquery',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Osquery comes with a powerful SQL abstractions layer to query hosts for various information that can be leveraged e.g. for network security. In standard deployment however, the hosts simply execute a statically defined schedule of queries, whose results might be useful for later analysis. Logs are forwarded to a central storage and can then be processed via arbitrary additional tools. With bro-osquery, we go beyond his standard use case with respect to several aspects.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The intention of bro-osquery is to collect host and network data by a common platform and to provide the ability to correlate them for network monitoring and intrusion detection. When monitoring either hosts or the network alone, the other one is a blind spot in your monitoring. But when monitoring both, information from hosts and network can perfectly complement each other. With their correlation, you gain more detailed knowledge about the activities of hosts and achieve a better visibility on the complete network infrastructure. The principle of correlation is to link host information for processes that emit traffic with network information for the corresponding packets.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In bro-osquery we implement this concept for the host monitor osquery and the Bro network IDS. By establishing a bi-directional publish-subscribe communication between osquery hosts and Bro, they can directly exchange data, i.e., SQL queries and their results. We provide a framework of Bro scripts that allows to run custom queries against all, individuals, or specific groups of hosts. Bro dynamically controls the query schedule of the hosts, retrieves and processes the corresponding data, and it can even asynchronously query hosts on demand for additional data.'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '2:30 pm',
	          end: '2:40 pm',
	          title: 'Break',
	          type: BREAK
	        }),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '2:45 pm',
	            category: 'osquery Development',
	            details: 'Trail of Bits',
	            end: '3:15 pm',
	            speaker: 'Lauren Pearl',
	            title: 'Three Super Features That Could Transform Osquery',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Not all features are created equally. Most features improve functionality. Some features expand a tool\u2019s ability so completely that the baseline product becomes something entirely new. We call these features Super Features.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In this talk, we\u2019ll review a user feature wishlist gathered from interviews with 5 Silicon Valley tech teams who use osquery. From these, we\u2019ll identify the Super Features - features that, if built, would fundamentally change the value proposition of osquery for the better. We\u2019ll explain how these developments could transform osquery\u2019s power in technical organizations.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finally, we\u2019ll walk through the steps to get there with high-level development plans for making these osquery Super Features a reality.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '3:15 pm',
	            category: 'osquery Development',
	            details: 'Airbnb',
	            end: '3:45 pm',
	            speaker: 'Samuel Keeley',
	            title: 'The Power of SQL: Complex queries at Your Fingertips',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Out of the box, osquery comes with many tables covering a wide array of information. When getting started, you might write queries against these tables to reveal specific information about services, files, applications, or similar that can be parsed with a tool like Zentral or Streamalert. However, these indvidual results might not paint the whole picture about the state of your fleet, especially if there are multiple conditions which need to be met and checked.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'By deeply diving into the power of SQL syntax we can make use of multiple tables and queries at the same time to find answers to complex questions, such as identifying software misconfigurations which lead to security vulnerabilties. Instead of relying solely on basic results and having to piece together data on the backend, we can use osquery to directly find complex state of processes, files, and other system states which are in need of remediation. The SQL interface for osquery is a unique one, but we will use it to find information which no other tool could give us in a simple way, and we will do it in just one (long) line.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '3:45 pm',
	            category: 'osquery Tools',
	            details: 'Zentral',
	            end: '4:15 pm',
	            speaker: 'Henry Stamerjohann',
	            title: 'Zentral - Osquery & Event Stream Processing Into the ElasticStack',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Learn about core functions and architecture of Zentral. Zentral is a open source hub to process event streams from osquery and other sources into the ElasticStack. Besides support for distinct osquery features like file carving, Zentral provides numerous integrations for inventory acquisition and alerting.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '4:15 pm',
	            category: 'osquery Development',
	            details: 'Carbon Black',
	            end: '4:45 pm',
	            speaker: 'Scott Lundgren',
	            title: 'An Outsider\'s Journey to Join the Osquery Community',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Imagine this: You discover osquery and find love at first sight. You have experience writing native systems code and ideas about new queries and want to do the right thing. A documented journey of an outside dev attempt to find his way in the community and make a meaningful contribution.'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '5:00 pm',
	          category: 'After-hours event',
	          details: '240 Front St, San Francisco, CA 94111',
	          end: '8:00 pm',
	          speaker: 'Schroeder\'s Restaurant',
	          title: 'Off-Site Dinner & Drinks',
	          type: WORKSHOP
	        })
	      ),
	      _react2.default.createElement('div', { className: _scheduleModule2.default.divider }),
	      _react2.default.createElement(
	        'div',
	        { className: _scheduleModule2.default.day, id: 'day2' },
	        _react2.default.createElement(
	          'h2',
	          { className: [_scheduleModule2.default.dayHeading, _scheduleModule2.default.dayHeadingMobile].join(' ') },
	          'June 1',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: _scheduleModule2.default.dayHeadingMobileDetail },
	            '(Day 2)'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '8:30 am',
	          day: 2,
	          end: '9:30 am',
	          title: 'Check-In / Breakfast',
	          type: MEAL
	        }),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '9:30 am',
	            category: 'People vs. Tools',
	            day: 2,
	            details: 'JASK',
	            end: '10:00 am',
	            speaker: 'Rob Fry',
	            title: 'SOC, aka Throw More People at the Problem',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The ',
	            "age of the API",
	            ', security orchestration, big data & ML have all come and gone, but SOCs are still outmanned and outgunned. There is now an ability to integrate systems, store large amounts of data and leverage algorithms to do what a SOC analyst does with machine speed, but how does a company leverage this data and these capabilities? Come see a history of these technologies applied to security and lessons learned on how to apply them.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '10:00 am',
	            category: 'osquery Internals',
	            day: 2,
	            details: 'Facebook',
	            end: '10:30 am',
	            speaker: 'Teddy Reed',
	            title: 'The Scary Parts of Osquery',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'This talk is meant to be 50% comical and 50% gut-wrenching horror. We will cover several of the older and more fragile components within osquery. We will highlight several assumptions that have been working well but lack testing coverage or rigorous review. This includes several potential exceptional edge cases that could be disastrous to performance or data integrity. We will conclude with several examples of how to make all of osquery more reliable and set up for a bright and sunny future!'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '10:30 am',
	            category: 'osquery Development',
	            day: 2,
	            details: 'Trail of Bits',
	            end: '11:00 am',
	            speaker: 'Mike Myers',
	            title: 'The Osquery Extensions Skunkworks Project: Unconventional Uses for Osquery',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Facebook created osquery with certain guiding principles: ',
	            'don\'t',
	            ' pry into',
	            'user\'s',
	            ' data, ',
	            'don\'t',
	            ' change the state of the system, ',
	            'don\'t',
	            ' create network traffic to third parties. For those that ',
	            'didn\'t',
	            ' want to play by these rules, they created the extension interface. ',
	            'We\'ve',
	            ' begun experimenting with what is possible with extensions that would not be with mainline osquery: integrating with third-party services, writable tables, host-based firewall administration, malware vaccination, and more. We will share some of our lessons-learned on the challenges of using osquery \u2014 originally intended as a read-only information gatherer \u2014 as a control interface.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '11:00 am',
	            category: 'osquery Development',
	            day: 2,
	            details: 'Facebook',
	            end: '11:30 am',
	            speaker: 'Mitchell Grenier',
	            title: 'Catching Everything with Osquery Events',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'This talk is designed for osquery developers and will be deep-dive into osquery internals. The osquery eventing tables, and the internal pubsub framework, make it possible to have osquery record data when it happens, not just when you query. We will go over what data already exists, queries that can be built on these for instant new detections, and how the framework is implemented so you can build exactly what you need.'
	          )
	        ),
	        _react2.default.createElement(
	          _ScheduleEntry.ScheduleEntry,
	          {
	            begin: '11:30 am',
	            category: 'Production osquery',
	            day: 2,
	            details: 'Uptycs',
	            end: '12:00 pm',
	            speaker: 'Milan Shah',
	            title: 'Osquery and Docker Containers',
	            type: TALK
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'In the past, osquery had major limitations in support for providing visibility into Docker containers. With the recent addition of 14 Docker related tables in osquery, new opportunities exist to address major use cases around resource optimization, intrusion detection and compliance for Docker environments. Combined with information from Kubernetes and SWARM \u2013 osquery can now help provide visibility across a containerized application.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In this talk, we will explore the recent Docker table additions to osquery, expose existing limitations to help guide future osquery developments and discuss the growing implications of osquery in a serverless world. Attendees will leave this session with an understanding of whether or not osquery can meet their needs for securing and monitoring a Docker container environment.'
	          )
	        ),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '12:00 pm',
	          day: 2,
	          end: '1:00 pm',
	          title: 'Lunch',
	          type: MEAL
	        }),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '1:00 pm',
	          category: WORKSHOP,
	          day: 2,
	          end: '4:00 pm',
	          speaker: 'Victor Vrantchan (and a few others!)',
	          title: 'Community Workshop',
	          type: WORKSHOP
	        }),
	        _react2.default.createElement(_ScheduleEntry.ScheduleEntry, {
	          begin: '4:00 pm',
	          day: 2,
	          details: 'Kolide',
	          end: '4:30 pm',
	          speaker: 'Jason Meller',
	          title: 'Wrap-Up & Thank You',
	          type: HOST
	        })
	      )
	    )
	  );
	};
	
	exports.default = Schedule;
	module.exports = exports['default'];

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dayHeadings":"src-components-Schedule----schedule-module---dayHeadings---17LWh","dayHeading":"src-components-Schedule----schedule-module---dayHeading---2yAin","mobileDayLinks":"src-components-Schedule----schedule-module---mobileDayLinks---3_se_","mobileDayLink":"src-components-Schedule----schedule-module---mobileDayLink---2Bju9","dayHeadingMobile":"src-components-Schedule----schedule-module---dayHeadingMobile---nUmDs","dayHeadingMobileDetail":"src-components-Schedule----schedule-module---dayHeadingMobileDetail---bWxce","events":"src-components-Schedule----schedule-module---events---3Wmp4","divider":"src-components-Schedule----schedule-module---divider---2wQCx","day":"src-components-Schedule----schedule-module---day---SuxA1"};

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ScheduleEntry = exports.ENTRY_TYPES = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scheduleEntryModule = __webpack_require__(339);
	
	var _scheduleEntryModule2 = _interopRequireDefault(_scheduleEntryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ENTRY_TYPES = exports.ENTRY_TYPES = {
	  BREAK: 'break',
	  HOST: 'host',
	  KEYNOTE: 'keynote',
	  MEAL: 'meal',
	  TALK: 'talk',
	  WORKSHOP: 'workshop'
	};
	
	var DAY_1 = 'May 31 - (Day 1)';
	var DAY_2 = 'June 1 - (Day 2)';
	var cx = _classnames2.default.bind(_scheduleEntryModule2.default);
	
	var ScheduleEntry = exports.ScheduleEntry = function (_React$Component) {
	  _inherits(ScheduleEntry, _React$Component);
	
	  function ScheduleEntry() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleEntry);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showDetails: false
	    }, _this.hideDetails = function () {
	      _this.setState({ showDetails: false });
	    }, _this.showDetails = function () {
	      _this.setState({ showDetails: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScheduleEntry.prototype.render = function render() {
	    var _cx;
	
	    var _props = this.props,
	        begin = _props.begin,
	        category = _props.category,
	        children = _props.children,
	        day = _props.day,
	        details = _props.details,
	        end = _props.end,
	        speaker = _props.speaker,
	        title = _props.title,
	        type = _props.type;
	    var showDetails = this.state.showDetails;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: cx(_scheduleEntryModule2.default.entry, (_cx = {}, _cx[_scheduleEntryModule2.default.break] = type === ENTRY_TYPES.BREAK, _cx[_scheduleEntryModule2.default.keynote] = type === ENTRY_TYPES.KEYNOTE, _cx[_scheduleEntryModule2.default.meal] = type === ENTRY_TYPES.MEAL, _cx[_scheduleEntryModule2.default.talk] = type === ENTRY_TYPES.TALK || type === ENTRY_TYPES.HOST, _cx[_scheduleEntryModule2.default.workshop] = type === ENTRY_TYPES.WORKSHOP, _cx))
	      },
	      _react2.default.createElement(
	        'h3',
	        { className: _scheduleEntryModule2.default.time },
	        day === 2 ? _react2.default.createElement(
	          'span',
	          { className: _scheduleEntryModule2.default.day },
	          'June 1 - (Day 2)'
	        ) : _react2.default.createElement(
	          'span',
	          { className: _scheduleEntryModule2.default.day },
	          'May 31 - (Day 1)'
	        ),
	        begin,
	        ' - ',
	        end
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _scheduleEntryModule2.default.entryBody },
	        category && _react2.default.createElement(
	          'div',
	          { className: _scheduleEntryModule2.default.category },
	          category
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: _scheduleEntryModule2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: _scheduleEntryModule2.default.speaker },
	          speaker
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _scheduleEntryModule2.default.details },
	          details
	        ),
	        (type === ENTRY_TYPES.TALK || type === ENTRY_TYPES.KEYNOTE) && _react2.default.createElement(
	          'div',
	          { className: _scheduleEntryModule2.default.details },
	          showDetails ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              children
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _scheduleEntryModule2.default.detailsToggle, onClick: this.hideDetails },
	              'Hide Details'
	            )
	          ) : _react2.default.createElement(
	            'button',
	            { className: _scheduleEntryModule2.default.detailsToggle, onClick: this.showDetails },
	            'Show Details'
	          )
	        )
	      )
	    );
	  };
	
	  return ScheduleEntry;
	}(_react2.default.Component);

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"entry":"src-components-ScheduleEntry----schedule-entry-module---entry---rwDSU","time":"src-components-ScheduleEntry----schedule-entry-module---time---255fL","day":"src-components-ScheduleEntry----schedule-entry-module---day---6Y2Et","entryBody":"src-components-ScheduleEntry----schedule-entry-module---entryBody---1Fs-X","detailsToggle":"src-components-ScheduleEntry----schedule-entry-module---detailsToggle---3hPfC","details":"src-components-ScheduleEntry----schedule-entry-module---details---8827j","break":"src-components-ScheduleEntry----schedule-entry-module---break---2TVxr","keynote":"src-components-ScheduleEntry----schedule-entry-module---keynote---2VvVC","meal":"src-components-ScheduleEntry----schedule-entry-module---meal---3-ZKw","talk":"src-components-ScheduleEntry----schedule-entry-module---talk---1DO09","workshop":"src-components-ScheduleEntry----schedule-entry-module---workshop---2-s-L","category":"src-components-ScheduleEntry----schedule-entry-module---category---5zuxa","title":"src-components-ScheduleEntry----schedule-entry-module---title---3Nv95","speaker":"src-components-ScheduleEntry----schedule-entry-module---speaker---2DS-O"};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexModule = __webpack_require__(340);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _dining = __webpack_require__(518);
	
	var _dining2 = _interopRequireDefault(_dining);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Social = function Social(_ref) {
	  var id = _ref.id;
	  return _react2.default.createElement(
	    'section',
	    { id: id, className: _indexModule2.default.social },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Social Event at ',
	      'Schroeder\'s'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.schroederssf.com/', rel: 'noopener noreferrer', target: '_blank' },
	        _react2.default.createElement('img', { alt: '', src: _dining2.default, className: _indexModule2.default.primaryImage })
	      ),
	      'Kolide will be hosting an after-hours event at ',
	      " ",
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.schroederssf.com/', rel: 'noopener noreferrer', target: '_blank' },
	        'Schroeder\'s',
	        ' Restaurant'
	      ),
	      ' ',
	      " ",
	      'from 5:00pm-8:00pm after the first day of QueryCon, on May 31st.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _indexModule2.default.socialDescription },
	      'Food and beverages will be provided, so come grab a drink, enjoy some hearty German-style fare, and hang out with your fellow osquery community. Lyft codes will be provided to help get you from the conference venue to the restaurant!'
	    )
	  );
	};
	
	exports.default = Social;
	module.exports = exports['default'];

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"social":"src-components-Social----index-module---social---3uuyL","primaryImage":"src-components-Social----index-module---primaryImage---1pWPH"};

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _speakerModule = __webpack_require__(341);
	
	var _speakerModule2 = _interopRequireDefault(_speakerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Speaker = function Speaker(_ref) {
	  var children = _ref.children,
	      company = _ref.company,
	      image = _ref.image,
	      image2x = _ref.image2x,
	      image3x = _ref.image3x,
	      name = _ref.name,
	      otherDescriptor = _ref.otherDescriptor,
	      presentationName = _ref.presentationName,
	      presentationTopic = _ref.presentationTopic,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: _speakerModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _speakerModule2.default.speaker },
	      _react2.default.createElement(
	        'div',
	        { className: _speakerModule2.default.presentationTopic },
	        presentationTopic
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _speakerModule2.default.presentationName },
	        presentationName
	      ),
	      children,
	      _react2.default.createElement(
	        'div',
	        { className: _speakerModule2.default.speakerInfo },
	        _react2.default.createElement(
	          'div',
	          { className: _speakerModule2.default.headshot },
	          _react2.default.createElement('img', {
	            alt: name,
	            className: _speakerModule2.default.headshotImg,
	            src: image,
	            srcSet: image2x + ' 2x, ' + image3x + ' 3x'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _speakerModule2.default.name },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _speakerModule2.default.title },
	            title,
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: _speakerModule2.default.company },
	              '@ ',
	              company,
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _speakerModule2.default.otherDescriptor },
	              otherDescriptor ? 'and ' + otherDescriptor : ""
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Speaker;
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Speaker----speaker-module---wrapper---Eyk3m","presentationTopic":"src-components-Speaker----speaker-module---presentationTopic---2XEyO","presentationName":"src-components-Speaker----speaker-module---presentationName---2B4ot","speaker":"src-components-Speaker----speaker-module---speaker---1fG9d","speakerInfo":"src-components-Speaker----speaker-module---speakerInfo---2jGlb","headshot":"src-components-Speaker----speaker-module---headshot---9oIah","headshotImg":"src-components-Speaker----speaker-module---headshotImg---34kbk","name":"src-components-Speaker----speaker-module---name---1KQzd","title":"src-components-Speaker----speaker-module---title---1IfSs","company":"src-components-Speaker----speaker-module---company---1qTF4","otherDescriptor":"src-components-Speaker----speaker-module---otherDescriptor---3vL2V"};

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headshotBenHughes = __webpack_require__(119);
	
	var _headshotBenHughes2 = _interopRequireDefault(_headshotBenHughes);
	
	var _headshotBenHughes2x = __webpack_require__(117);
	
	var _headshotBenHughes2x2 = _interopRequireDefault(_headshotBenHughes2x);
	
	var _headshotBenHughes3x = __webpack_require__(118);
	
	var _headshotBenHughes3x2 = _interopRequireDefault(_headshotBenHughes3x);
	
	var _headshotChrisLong = __webpack_require__(122);
	
	var _headshotChrisLong2 = _interopRequireDefault(_headshotChrisLong);
	
	var _headshotChrisLong2x = __webpack_require__(120);
	
	var _headshotChrisLong2x2 = _interopRequireDefault(_headshotChrisLong2x);
	
	var _headshotChrisLong3x = __webpack_require__(121);
	
	var _headshotChrisLong3x2 = _interopRequireDefault(_headshotChrisLong3x);
	
	var _headshotLaurenPearl = __webpack_require__(125);
	
	var _headshotLaurenPearl2 = _interopRequireDefault(_headshotLaurenPearl);
	
	var _headshotLaurenPearl2x = __webpack_require__(123);
	
	var _headshotLaurenPearl2x2 = _interopRequireDefault(_headshotLaurenPearl2x);
	
	var _headshotLaurenPearl3x = __webpack_require__(124);
	
	var _headshotLaurenPearl3x2 = _interopRequireDefault(_headshotLaurenPearl3x);
	
	var _headshotMichaelLynn = __webpack_require__(527);
	
	var _headshotMichaelLynn2 = _interopRequireDefault(_headshotMichaelLynn);
	
	var _headshotMichaelLynn2x = __webpack_require__(525);
	
	var _headshotMichaelLynn2x2 = _interopRequireDefault(_headshotMichaelLynn2x);
	
	var _headshotMichaelLynn3x = __webpack_require__(526);
	
	var _headshotMichaelLynn3x2 = _interopRequireDefault(_headshotMichaelLynn3x);
	
	var _headshotHenryStamerjohan = __webpack_require__(524);
	
	var _headshotHenryStamerjohan2 = _interopRequireDefault(_headshotHenryStamerjohan);
	
	var _headshotHenryStamerjohan2x = __webpack_require__(522);
	
	var _headshotHenryStamerjohan2x2 = _interopRequireDefault(_headshotHenryStamerjohan2x);
	
	var _headshotHenryStamerjohan3x = __webpack_require__(523);
	
	var _headshotHenryStamerjohan3x2 = _interopRequireDefault(_headshotHenryStamerjohan3x);
	
	var _headshotMikeArpaia = __webpack_require__(128);
	
	var _headshotMikeArpaia2 = _interopRequireDefault(_headshotMikeArpaia);
	
	var _headshotMikeArpaia2x = __webpack_require__(126);
	
	var _headshotMikeArpaia2x2 = _interopRequireDefault(_headshotMikeArpaia2x);
	
	var _headshotMikeArpaia3x = __webpack_require__(127);
	
	var _headshotMikeArpaia3x2 = _interopRequireDefault(_headshotMikeArpaia3x);
	
	var _headshotMikeMyers = __webpack_require__(131);
	
	var _headshotMikeMyers2 = _interopRequireDefault(_headshotMikeMyers);
	
	var _headshotMikeMyers2x = __webpack_require__(129);
	
	var _headshotMikeMyers2x2 = _interopRequireDefault(_headshotMikeMyers2x);
	
	var _headshotMikeMyers3x = __webpack_require__(130);
	
	var _headshotMikeMyers3x2 = _interopRequireDefault(_headshotMikeMyers3x);
	
	var _headshotMitchellGrenier = __webpack_require__(134);
	
	var _headshotMitchellGrenier2 = _interopRequireDefault(_headshotMitchellGrenier);
	
	var _headshotMitchellGrenier2x = __webpack_require__(132);
	
	var _headshotMitchellGrenier2x2 = _interopRequireDefault(_headshotMitchellGrenier2x);
	
	var _headshotMitchellGrenier3x = __webpack_require__(133);
	
	var _headshotMitchellGrenier3x2 = _interopRequireDefault(_headshotMitchellGrenier3x);
	
	var _headshotNickAnderson = __webpack_require__(137);
	
	var _headshotNickAnderson2 = _interopRequireDefault(_headshotNickAnderson);
	
	var _headshotNickAnderson2x = __webpack_require__(135);
	
	var _headshotNickAnderson2x2 = _interopRequireDefault(_headshotNickAnderson2x);
	
	var _headshotNickAnderson3x = __webpack_require__(136);
	
	var _headshotNickAnderson3x2 = _interopRequireDefault(_headshotNickAnderson3x);
	
	var _headshotTedReed = __webpack_require__(143);
	
	var _headshotTedReed2 = _interopRequireDefault(_headshotTedReed);
	
	var _headshotTedReed2x = __webpack_require__(141);
	
	var _headshotTedReed2x2 = _interopRequireDefault(_headshotTedReed2x);
	
	var _headshotTedReed3x = __webpack_require__(142);
	
	var _headshotTedReed3x2 = _interopRequireDefault(_headshotTedReed3x);
	
	var _headshotSamuelKeeley = __webpack_require__(533);
	
	var _headshotSamuelKeeley2 = _interopRequireDefault(_headshotSamuelKeeley);
	
	var _headshotSamuelKeeley2x = __webpack_require__(531);
	
	var _headshotSamuelKeeley2x2 = _interopRequireDefault(_headshotSamuelKeeley2x);
	
	var _headshotSamuelKeeley3x = __webpack_require__(532);
	
	var _headshotSamuelKeeley3x2 = _interopRequireDefault(_headshotSamuelKeeley3x);
	
	var _headshotScottLundgren = __webpack_require__(536);
	
	var _headshotScottLundgren2 = _interopRequireDefault(_headshotScottLundgren);
	
	var _headshotScottLundgren2x = __webpack_require__(534);
	
	var _headshotScottLundgren2x2 = _interopRequireDefault(_headshotScottLundgren2x);
	
	var _headshotScottLundgren3x = __webpack_require__(535);
	
	var _headshotScottLundgren3x2 = _interopRequireDefault(_headshotScottLundgren3x);
	
	var _headshotMilanShah = __webpack_require__(530);
	
	var _headshotMilanShah2 = _interopRequireDefault(_headshotMilanShah);
	
	var _headshotMilanShah2x = __webpack_require__(528);
	
	var _headshotMilanShah2x2 = _interopRequireDefault(_headshotMilanShah2x);
	
	var _headshotMilanShah3x = __webpack_require__(529);
	
	var _headshotMilanShah3x2 = _interopRequireDefault(_headshotMilanShah3x);
	
	var _headshotForestMonsen = __webpack_require__(521);
	
	var _headshotForestMonsen2 = _interopRequireDefault(_headshotForestMonsen);
	
	var _headshotForestMonsen2x = __webpack_require__(519);
	
	var _headshotForestMonsen2x2 = _interopRequireDefault(_headshotForestMonsen2x);
	
	var _headshotForestMonsen3x = __webpack_require__(520);
	
	var _headshotForestMonsen3x2 = _interopRequireDefault(_headshotForestMonsen3x);
	
	var _headshotSteffanHaas = __webpack_require__(539);
	
	var _headshotSteffanHaas2 = _interopRequireDefault(_headshotSteffanHaas);
	
	var _headshotSteffanHaas2x = __webpack_require__(537);
	
	var _headshotSteffanHaas2x2 = _interopRequireDefault(_headshotSteffanHaas2x);
	
	var _headshotSteffanHaas3x = __webpack_require__(538);
	
	var _headshotSteffanHaas3x2 = _interopRequireDefault(_headshotSteffanHaas3x);
	
	var _headshotRobFry = __webpack_require__(140);
	
	var _headshotRobFry2 = _interopRequireDefault(_headshotRobFry);
	
	var _headshotRobFry2x = __webpack_require__(138);
	
	var _headshotRobFry2x2 = _interopRequireDefault(_headshotRobFry2x);
	
	var _headshotRobFry3x = __webpack_require__(139);
	
	var _headshotRobFry3x2 = _interopRequireDefault(_headshotRobFry3x);
	
	var _programModule = __webpack_require__(169);
	
	var _programModule2 = _interopRequireDefault(_programModule);
	
	var _Speaker = __webpack_require__(233);
	
	var _Speaker2 = _interopRequireDefault(_Speaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Speakers = function Speakers(_ref) {
	  var id = _ref.id;
	  return _react2.default.createElement(
	    'section',
	    { id: id },
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Facebook',
	        image: _headshotNickAnderson2.default,
	        image2x: _headshotNickAnderson2x2.default,
	        image3x: _headshotNickAnderson3x2.default,
	        name: 'Nick Anderson',
	        presentationName: 'Evolving Our Open Source Community',
	        presentationTopic: 'Keynote'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Over the past two years the osquery community has increased dramatically. Not only have the number of contributions to the agent dramatically bumped, so has the number of platforms we support and richness of discussions in our community around best leveraging osquery.',
	        'We\'ll',
	        ' explore how our community has grown, problems we faced/still face, and the directions ',
	        'we\'re',
	        ' hoping to push the community forward.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Palantir',
	        image: _headshotChrisLong2.default,
	        image2x: _headshotChrisLong2x2.default,
	        image3x: _headshotChrisLong3x2.default,
	        name: 'Chris Long',
	        presentationName: 'Practical System Auditing with Osquery',
	        presentationTopic: 'Production Osquery',
	        title: 'Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'While there are many different ways to audit process executions and network events on Linux-based systems, osquery provides a fairly unique interface for collecting and filtering audit-based events. However, there are some common misconceptions surrounding the audit framework and digging through documentation on it can be quite perplexing. During this talk ',
	        'we\'ll',
	        ' cover:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _programModule2.default.bullets },
	        _react2.default.createElement(
	          'li',
	          null,
	          'A basic overview of the audit framework'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Building a basic osquery auditing configuration'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Fine-tune auditing configurations to minimize performance impact against your systems'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Palantir currently maintains an osquery deployment consisting of thousands of hosts with auditing enabled and collects upwards of 1 billion process and socket events per day. Join this talk to learn how to gain greater visibility into high-value systems, scale an auditing deployment, or simply learn more about ',
	        'osquery\'s',
	        ' auditing features.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Netflix',
	        image: _headshotForestMonsen2.default,
	        image2x: _headshotForestMonsen2x2.default,
	        image3x: _headshotForestMonsen3x2.default,
	        name: 'Forest Monsen',
	        presentationName: 'An Osquery-Based Differencing Engine for Incident Response',
	        presentationTopic: 'Osquery Tools',
	        title: 'Senior Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'During a security incident on your cloud architecture, how far have attackers penetrated? How many instances have they touched, and what have they done there? Diffy will help. Using osquery, and a selection of simple differencing and more sophisticated clustering methods, Diffy will quickly point you to those instances requiring further digital forensics actions.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Stripe',
	        image: _headshotBenHughes2.default,
	        image2x: _headshotBenHughes2x2.default,
	        image3x: _headshotBenHughes3x2.default,
	        name: 'Ben Hughes',
	        presentationName: 'Osquery, He Knows Me',
	        presentationTopic: 'Production Osquery',
	        title: 'Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'This talk, aimed at everyone, highlights the journey from before Osquery in my time with the Etsy security team, and some of the tooling and problems we faced. The wrong decisions ',
	        'I\'ve',
	        ' made, so you can learn from my foolish hubris. To a number of thousand deployment of Osquery (and fleet and some not so fleet) at Stripe.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Kolide',
	        image: _headshotMikeArpaia2.default,
	        image2x: _headshotMikeArpaia2x2.default,
	        image3x: _headshotMikeArpaia3x2.default,
	        name: 'Mike Arpaia',
	        presentationName: 'Instrumenting Dynamic Environments with Source Control, Peer Review, and Decentralized Intelligence Distribution',
	        presentationTopic: 'Osquery Tools',
	        title: 'Co-Founder & CTO'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Osquery configurations often start simple and static, but, as the complexity of an osquery deployment grows, the level of dynamicism grows to where a complex server installation is required to group sets of hosts together and target them for analytics and threat hunting.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This talk introduces some lessons learned from Kubernetes, a container orchestration platform, on how to effectively decouple and manage configurations of interrelated components.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We will discuss how to reason about higher level instrumentation objectives and share components as decentralized, atomically distributable intelligence.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Finally, the open-source ecosystem and established best practices will be explored so that attendees can begin implementing this way of managing and sharing host instrumentation capabilities and see immediate improvements to their instrumentation capabilities.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Facebook',
	        image: _headshotMichaelLynn2.default,
	        image2x: _headshotMichaelLynn2x2.default,
	        image3x: _headshotMichaelLynn3x2.default,
	        name: 'Michael Lynn',
	        presentationName: 'Fact Finding',
	        presentationTopic: 'Osquery Development',
	        title: 'Client Platform Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'The macOS UI provides a large amount of device information - but not every interface has a counterpart command-line tool providing access to the same details. This talk will focus on using tools like Hopper to reverse engineer the code and APIs behind information displays you see everyday and how to integrate access to them into your own tools.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'University of Hamburg',
	        image: _headshotSteffanHaas2.default,
	        image2x: _headshotSteffanHaas2x2.default,
	        image3x: _headshotSteffanHaas3x2.default,
	        name: 'Steffen Haas',
	        presentationName: 'Bro-Osquery',
	        presentationTopic: 'Osquery Tools',
	        title: 'Security Researcher and PhD Student'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Osquery comes with a powerful SQL abstractions layer to query hosts for various information that can be leveraged e.g. for network security. In standard deployment however, the hosts simply execute a statically defined schedule of queries, whose results might be useful for later analysis. Logs are forwarded to a central storage and can then be processed via arbitrary additional tools. With bro-osquery, we go beyond his standard use case with respect to several aspects.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The intention of bro-osquery is to collect host and network data by a common platform and to provide the ability to correlate them for network monitoring and intrusion detection. When monitoring either hosts or the network alone, the other one is a blind spot in your monitoring. But when monitoring both, information from hosts and network can perfectly complement each other. With their correlation, you gain more detailed knowledge about the activities of hosts and achieve a better visibility on the complete network infrastructure. The principle of correlation is to link host information for processes that emit traffic with network information for the corresponding packets.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In bro-osquery we implement this concept for the host monitor osquery and the Bro network IDS. By establishing a bi-directional publish-subscribe communication between osquery hosts and Bro, they can directly exchange data, i.e., SQL queries and their results. We provide a framework of Bro scripts that allows to run custom queries against all, individuals, or specific groups of hosts. Bro dynamically controls the query schedule of the hosts, retrieves and processes the corresponding data, and it can even asynchronously query hosts on demand for additional data.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Trail of Bits',
	        image: _headshotLaurenPearl2.default,
	        image2x: _headshotLaurenPearl2x2.default,
	        image3x: _headshotLaurenPearl3x2.default,
	        name: 'Lauren Pearl',
	        presentationName: 'Three Super Features That Could Transform Osquery',
	        presentationTopic: 'Osquery Development',
	        title: 'Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Not all features are created equally. Most features improve functionality. Some features expand a tool\u2019s ability so completely that the baseline product becomes something entirely new. We call these features Super Features.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In this talk, we\u2019ll review a user feature wishlist gathered from interviews with 5 Silicon Valley tech teams who use osquery. From these, we\u2019ll identify the Super Features - features that, if built, would fundamentally change the value proposition of osquery for the better. We\u2019ll explain how these developments could transform osquery\u2019s power in technical organizations.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Finally, we\u2019ll walk through the steps to get there with high-level development plans for making these osquery Super Features a reality.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Airbnb',
	        image: _headshotSamuelKeeley2.default,
	        image2x: _headshotSamuelKeeley2x2.default,
	        image3x: _headshotSamuelKeeley3x2.default,
	        name: 'Samuel Keeley',
	        presentationName: 'The power of SQL: Complex queries at your fingertips',
	        presentationTopic: 'Osquery Development',
	        title: 'Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Out of the box, osquery comes with many tables covering a wide array of information. When getting started, you might write queries against these tables to reveal specific information about services, files, applications, or similar that can be parsed with a tool like Zentral or Streamalert. However, these indvidual results might not paint the whole picture about the state of your fleet, especially if there are multiple conditions which need to be met and checked.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'By deeply diving into the power of SQL syntax we can make use of multiple tables and queries at the same time to find answers to complex questions, such as identifying software misconfigurations which lead to security vulnerabilties. Instead of relying solely on basic results and having to piece together data on the backend, we can use osquery to directly find complex state of processes, files, and other system states which are in need of remediation. The SQL interface for osquery is a unique one, but we will use it to find information which no other tool could give us in a simple way, and we will do it in just one (long) line.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Apfelwerk GmbH & Co. KG',
	        image: _headshotHenryStamerjohan2.default,
	        image2x: _headshotHenryStamerjohan2x2.default,
	        image3x: _headshotHenryStamerjohan3x2.default,
	        name: 'Henry Stamerjohann',
	        otherDescriptor: 'Zentral co-creator',
	        presentationName: 'Zentral - Osquery & Event Stream Processing into the ElasticStack',
	        presentationTopic: 'Osquery Tools',
	        title: 'Lead Systems Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Learn about core functions and architecture of Zentral. Zentral is a open source hub to process event streams from osquery and other sources into the ElasticStack. Besides support for distinct osquery features like file carving, Zentral provides numerous integrations for inventory acquisition and alerting.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Carbon Black',
	        image: _headshotScottLundgren2.default,
	        image2x: _headshotScottLundgren2x2.default,
	        image3x: _headshotScottLundgren3x2.default,
	        name: 'Scott Lundgren',
	        presentationName: 'An Outsider\'s Journey to Join the Osquery Community',
	        presentationTopic: 'Osquery Development',
	        title: 'Chief Architect'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Imagine this: You discover osquery and find love at first sight. You have experience writing native systems code and ideas about new queries and want to do the right thing. A documented journey of an outside dev attempt to find his way in the community and make a meaningful contribution.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'JASK',
	        image: _headshotRobFry2.default,
	        image2x: _headshotRobFry2x2.default,
	        image3x: _headshotRobFry3x2.default,
	        name: 'Rob Fry',
	        presentationName: 'SOC, aka Throw More People at the Problem',
	        presentationTopic: 'People vs Tools',
	        title: 'VP of Engineering'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'The ',
	        "age of the API",
	        ', security orchestration, big data & ML have all come and gone, but SOCs are still outmanned and outgunned. There is now an ability to integrate systems, store large amounts of data and leverage algorithms to do what a SOC analyst does with machine speed, but how does a company leverage this data and these capabilities? Come see a history of these technologies applied to security and lessons learned on how to apply them.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Facebook',
	        image: _headshotTedReed2.default,
	        image2x: _headshotTedReed2x2.default,
	        image3x: _headshotTedReed3x2.default,
	        name: 'Teddy Reed',
	        presentationName: 'The Scary Parts of Osquery',
	        presentationTopic: 'Osquery Internals',
	        title: 'Security Engineering Manager'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'This talk is meant to be 50% comical and 50% gut-wrenching horror. We will cover several of the older and more fragile components within osquery. We will highlight several assumptions that have been working well but lack testing coverage or rigorous review. This includes several potential exceptional edge cases that could be disastrous to performance or data integrity. We will conclude with several examples of how to make all of osquery more reliable and set up for a bright and sunny future!'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Trail of Bits',
	        image: _headshotMikeMyers2.default,
	        image2x: _headshotMikeMyers2x2.default,
	        image3x: _headshotMikeMyers3x2.default,
	        name: 'Mike Myers',
	        presentationName: 'The Osquery Extensions Skunkworks Project: Unconventional Uses for Osquery',
	        presentationTopic: 'Osquery Development',
	        title: 'Security Researcher'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Facebook created osquery with certain guiding principles: ',
	        'don\'t',
	        ' pry into',
	        'user\'s',
	        ' data, ',
	        'don\'t',
	        ' change the state of the system, ',
	        'don\'t',
	        ' create network traffic to third parties. For those that ',
	        'didn\'t',
	        ' want to play by these rules, they created the extension interface. ',
	        'We\'ve',
	        ' begun experimenting with what is possible with extensions that would not be with mainline osquery: integrating with third-party services, writable tables, host-based firewall administration, malware vaccination, and more. We will share some of our lessons-learned on the challenges of using osquery \u2014 originally intended as a read-only information gatherer \u2014 as a control interface.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Facebook',
	        image: _headshotMitchellGrenier2.default,
	        image2x: _headshotMitchellGrenier2x2.default,
	        image3x: _headshotMitchellGrenier3x2.default,
	        name: 'Mitchell Grenier',
	        presentationName: 'Catching Everything With Osquery Events',
	        presentationTopic: 'Osquery Development',
	        title: 'Security Engineer'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'This talk is designed for osquery developers and will be deep-dive into osquery internals. The osquery eventing tables, and the internal pubsub framework, make it possible to have osquery record data when it happens, not just when you query. We will go over what data already exists, queries that can be built on these for instant new detections, and how the framework is implemented so you can build exactly what you need.'
	      )
	    ),
	    _react2.default.createElement(
	      _Speaker2.default,
	      {
	        company: 'Uptycs',
	        image: _headshotMilanShah2.default,
	        image2x: _headshotMilanShah2x2.default,
	        image3x: _headshotMilanShah3x2.default,
	        name: 'Milan Shah',
	        presentationName: 'Osquery and Docker Containers',
	        presentationTopic: 'Production Osquery',
	        title: 'Co-Founder and CTO'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'In the past, osquery had major limitations in support for providing visibility into Docker containers. With the recent addition of 14 Docker related tables in osquery, new opportunities exist to address major use cases around resource optimization, intrusion detection and compliance for Docker environments. Combined with information from Kubernetes and SWARM \u2013 osquery can now help provide visibility across a containerized application.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In this talk, we will explore the recent Docker table additions to osquery, expose existing limitations to help guide future osquery developments and discuss the growing implications of osquery in a serverless world. Attendees will leave this session with an understanding of whether or not osquery can meet their needs for securing and monitoring a Docker container environment.'
	      )
	    )
	  );
	};
	
	exports.default = Speakers;
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(16);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _tabModule = __webpack_require__(343);
	
	var _tabModule2 = _interopRequireDefault(_tabModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tab = function Tab(props) {
	  var _classnames;
	
	  var active = props.active,
	      className = props.className,
	      onClick = props.onClick,
	      size = props.size,
	      text = props.text;
	
	  var classes = (0, _classnames3.default)(_tabModule2.default.tab, className, (_classnames = {}, _classnames[_tabModule2.default.activeTab] = active, _classnames[_tabModule2.default.smallTab] = size === 'small', _classnames[_tabModule2.default.largeTab] = size === 'large', _classnames));
	
	  return _react2.default.createElement(
	    'button',
	    { className: classes, onClick: onClick },
	    text
	  );
	};
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tab":"src-components-Tab----tab-module---tab---tA_rJ","activeTab":"src-components-Tab----tab-module---activeTab---sKFsF","smallTab":"src-components-Tab----tab-module---smallTab---26HLV","largeTab":"src-components-Tab----tab-module---largeTab---2G30q"};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexModule = __webpack_require__(346);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Workshop = function Workshop(_ref) {
	  var id = _ref.id;
	  return _react2.default.createElement(
	    'section',
	    { className: _indexModule2.default.workshop, id: id },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Community Workshop'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Many of us who attend conferences know that the \u201Challway track\u201D is often the most rewarding part of going to a conference in person. Talks are often recorded, and anyone can watch them online, but the hallway track is a chance to make once-in-a-lifetime connections, share your ideas for a side project with someone else, or get help on a hard-to-debug issue from just the right person. It\u2019s where you build meaningful relationships, and grow your network. We\u2019re taking the hallway track and making it official.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our community workshop will be a half-day event, right after the talks, on day two of QueryCon. During the workshop, we\u2019ll form expertly lead groups to dive into topics that you\u2019re interested in. Feel free to jump around between topics, and enjoy beer and wine with the community while you learn.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Suggested Topics:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: _indexModule2.default.bullets },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Logging Pipelines: Using osquery with ELK'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Getting started with TLS'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'SQL: Writing your queries to return the right results'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'SQL: Writing performant pipelines'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Contributing to osquery: Your first table'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Writing osquery plugins'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Have a topic you\u2019d be interested in? Want to facilitate one of the groups?',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { className: _indexModule2.default.contactLink, href: 'mailto:info@querycon.io' },
	        'Drop us a line!'
	      )
	    )
	  );
	};
	
	exports.default = Workshop;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"workshop":"src-components-Workshop----index-module---workshop---M4qyc","bullets":"src-components-Workshop----index-module---bullets---29tAq","contactLink":"src-components-Workshop----index-module---contactLink---2r8tf"};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dining.4cade79f.jpg";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ben-hughes-2x.e771b40e.jpg";

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ben-hughes-3x.87b455b4.jpg";

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ben-hughes.3ed41494.jpg";

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-chris-long-2x.78bab3a6.jpg";

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-chris-long-3x.e19ac6e0.jpg";

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-chris-long.bcc5e52f.jpg";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-forest-monsen-2x.f27a988b.jpg";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-forest-monsen-3x.6953c754.jpg";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-forest-monsen.dcb006d8.jpg";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-henry-stamerjohan-2x.53ee6784.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-henry-stamerjohan-3x.33143994.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-henry-stamerjohan.68952dcb.jpg";

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-lauren-pearl-2x.1a504d00.jpg";

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-lauren-pearl-3x.1bdb70c2.jpg";

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-lauren-pearl.d815874f.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-michael-lynn-2x.c1336d05.jpg";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-michael-lynn-3x.1b15331f.jpg";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-michael-lynn.895e2d85.jpg";

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-arpaia-2x.d04fb0c6.jpg";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-arpaia-3x.d5d0d653.jpg";

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-arpaia.ff4aac71.jpg";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-myers-2x.def246d8.jpg";

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-myers-3x.2a53534c.jpg";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mike-myers.298c2287.jpg";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-milan-shah-2x.db627cce.jpg";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-milan-shah-3x.17f651be.jpg";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-milan-shah.6fa54f61.jpg";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mitchell-grenier-2x.fe488a46.jpg";

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mitchell-grenier-3x.19e3a0b8.jpg";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-mitchell-grenier.a3b691b7.jpg";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-nick-anderson-2x.0bacbf64.png";

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-nick-anderson-3x.6cd81e46.png";

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-nick-anderson.9a377716.png";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-rob-fry-2x.715fa826.jpg";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-rob-fry-3x.a264dd93.jpg";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-rob-fry.e03993c9.jpg";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-samuel-keeley-2x.ad4540cd.jpg";

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-samuel-keeley-3x.c342e5b8.jpg";

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-samuel-keeley.8bae1fcb.jpg";

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-scott-lundgren-2x.adb4962f.jpg";

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-scott-lundgren-3x.4ef120dc.jpg";

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-scott-lundgren.259769a5.jpg";

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-steffan-haas-2x.4971f0e7.jpg";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-steffan-haas-3x.0e2ea089.jpg";

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-steffan-haas.daa3f07e.jpg";

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ted-reed-2x.bda4e32d.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ted-reed-3x.417c663c.jpg";

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot-ted-reed.586045dd.jpg";

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(70);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactResponsive = __webpack_require__(37);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Footer = __webpack_require__(51);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(52);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _MobileHeader = __webpack_require__(53);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _Schedule = __webpack_require__(230);
	
	var _Schedule2 = _interopRequireDefault(_Schedule);
	
	var _Social = __webpack_require__(232);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _Speakers = __webpack_require__(235);
	
	var _Speakers2 = _interopRequireDefault(_Speakers);
	
	var _Tab = __webpack_require__(236);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Workshop = __webpack_require__(239);
	
	var _Workshop2 = _interopRequireDefault(_Workshop);
	
	var _programModule = __webpack_require__(169);
	
	var _programModule2 = _interopRequireDefault(_programModule);
	
	var _constants = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCHEDULE = 'schedule';
	var SPEAKERS = 'speakers';
	var WORKSHOP = 'workshop';
	var SOCIAL = 'social';
	
	var ProgramPage = function (_Component) {
	  _inherits(ProgramPage, _Component);
	
	  function ProgramPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProgramPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.showContent = function (tabName) {
	      return function () {
	        window.location.hash = tabName;
	        _this.setState({ activeTab: tabName });
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProgramPage.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ activeTab: this.activeTab });
	  };
	
	  ProgramPage.prototype.render = function render() {
	    var activeTab = this.state.activeTab;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _programModule2.default.content },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'QueryCon18 - Program'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Program' })
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: _constants.DESKTOP_MIN_WIDTH },
	        _react2.default.createElement(_Header2.default, { dark: true })
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: _constants.MOBILE_WIDTH },
	        _react2.default.createElement(_MobileHeader2.default, null)
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: _programModule2.default.h2 },
	        'Program'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _programModule2.default.tabs },
	        _react2.default.createElement(_Tab2.default, {
	          active: activeTab === SCHEDULE,
	          onClick: this.showContent(SCHEDULE),
	          size: 'large',
	          text: 'Schedule'
	        }),
	        _react2.default.createElement(_Tab2.default, {
	          active: activeTab === SPEAKERS,
	          onClick: this.showContent(SPEAKERS),
	          size: 'large',
	          text: 'Speakers'
	        }),
	        _react2.default.createElement(_Tab2.default, {
	          active: activeTab === WORKSHOP,
	          onClick: this.showContent(WORKSHOP),
	          size: 'large',
	          text: 'Workshop'
	        }),
	        _react2.default.createElement(_Tab2.default, {
	          active: activeTab === SOCIAL,
	          onClick: this.showContent(SOCIAL),
	          size: 'large',
	          text: 'Social'
	        })
	      ),
	      _react2.default.createElement('div', { className: _programModule2.default.sectionBreak }),
	      _react2.default.createElement(ProgramSections, { activeTab: activeTab }),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  _createClass(ProgramPage, [{
	    key: 'activeTab',
	    get: function get() {
	      var hashLocation = this.props.location.hash.replace('#', '');
	
	      if (hashLocation === SPEAKERS || hashLocation === WORKSHOP || hashLocation === SOCIAL) {
	        return hashLocation;
	      } else {
	        return SCHEDULE;
	      }
	    }
	  }]);
	
	  return ProgramPage;
	}(_react.Component);
	
	var ProgramSections = function ProgramSections(_ref) {
	  var activeTab = _ref.activeTab;
	
	  if (activeTab === WORKSHOP) {
	    return _react2.default.createElement(_Workshop2.default, { id: WORKSHOP });
	  } else if (activeTab === SPEAKERS) {
	    return _react2.default.createElement(_Speakers2.default, { id: SPEAKERS });
	  } else if (activeTab === SOCIAL) {
	    return _react2.default.createElement(_Social2.default, { id: SOCIAL });
	  } else {
	    return _react2.default.createElement(_Schedule2.default, { id: SCHEDULE });
	  }
	};
	
	exports.default = ProgramPage;
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hidden":"src-pages-program----program-module---hidden---3v4i8","h2":"src-pages-program----program-module---h2---1PKbM","tabs":"src-pages-program----program-module---tabs---1Rpvr","sectionBreak":"src-pages-program----program-module---sectionBreak---yq7kk","bullets":"src-pages-program----program-module---bullets---1Hn9c"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-program-index-js-9cf0b702d71c5fa4a56b.js